(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment historie item
    module.controller('AgendaAppointmentHistorieItemController',
        ['AppointmentState', AgendaAppointmentHistorieItemControllerFn]);

    function AgendaAppointmentHistorieItemControllerFn(AppointmentState) {
        var vm = this;

        // current appointment state
        vm.state = null;

        activate();               

        // activation work
        function activate() {
            // get current appointment state
            angular.forEach(AppointmentState, function (state) {
                if (state.value === vm.appointment.appointmentState) {
                    vm.state = state;
                    return;
                } //if
            });
        } // activate

    }

})();